import React, { useMemo } from "react";
import EditNoteDetails from "./EditNoteDetails";
import CptHeader from "./CptHeader";
import ViewNoteDetails from "./ViewNoteDetails";
import { createHash } from "utils/crypto";

const getCacheHashId = ({ videoId, clinicianUserId }) => {
  const hash = createHash("md5")
    .update(
      JSON.stringify({
        videoId: String(videoId),
        clinicianUserId: String(clinicianUserId),
      })
    )
    .digest("hex");
  return hash;
};

const NoteDetails = (props) => {
  const {
    viewOnly,
    videoId,
    clinicianUserId,
    serviceType,
    billableTimeId,
    clientData,
    generate,
    setAiProcessSucceeded,
  } = props;

  const serviceTypeCode = String(serviceType?.code || "");

  const processData = useMemo(() => {
    if (!videoId || !clinicianUserId || !serviceTypeCode) {
      return null;
    }
    const cacheHashId = getCacheHashId({ videoId, clinicianUserId });

    // Map Fidelis codes to their corresponding 97 codes for targetProcess
    const normalizedCode =
      serviceTypeCode === "FI153"
        ? "97153"
        : serviceTypeCode === "FI156"
          ? "97156"
          : serviceTypeCode;

    return {
      targetProcess: `generateSessionNotes_${normalizedCode}_v2`,
      platformContext: {
        resourceType: "video_call",
        resourceId: videoId,
        responseType: "summary",
        metadata: {
          clinicianUserId,
          billableTimeId,
          clientName: clientData?.child_name,
        },
      },
      cacheHashId,
    };
  }, [videoId, clinicianUserId, serviceTypeCode, billableTimeId, clientData?.child_name]);

  const handleRegenerate = () => {
    // Skip the cache check and force a new init.json upload and delete the old req folder
    if (processData) {
      const retryData = {
        ...processData,
        platformContext: {
          ...processData.platformContext,
          forceUpload: true,
          deleteRequestFolder: true,
        },
      };
      // Reset the success flag so the generating indicator shows during regeneration
      setAiProcessSucceeded(false);
      // 10 second polling delay to allow the process to start before polling begins
      generate(retryData, { pollingDelay: 10000 });
    }
  };

  return (
    <>
      <CptHeader {...props} onRegenerate={handleRegenerate} />
      {viewOnly ? (
        <ViewNoteDetails {...props} />
      ) : (
        <EditNoteDetails {...props} processData={processData} onRegenerate={handleRegenerate} />
      )}
    </>
  );
};

export default NoteDetails;
